import ListPageFilterDropdown from './ListPageFilterDropdown';
import styles from '../../styles/Components/Shared/PageTabs.module.css';

const PageTabs = ({ tabs, selectedTab, handleChangeTab, desktopStyles = '', mobileStyles = '', mobileDropdownLabel }) => {
    
    return tabs?.length > 0 ? (
        <>
            <div className={`${styles.page_tab_container} ${desktopStyles}`}>
                {tabs.map((tab, i) => (
                    <p 
                        key={`tab-${i}`}
                        className={`${styles.page_tab} ${selectedTab === tab.subRoute || (!selectedTab && i === 0) ? styles.page_tab_selected : ''}`}
                        onClick={() => handleChangeTab(tab.subRoute)}
                    >
                        {tab.name}
                    </p>
                ))}
            </div>
            <div className={`input_container ${styles.page_tab_mobile_dropdown} ${mobileStyles}`}>
                
                <ListPageFilterDropdown
                    title={'Select Section'}
                    options={tabs.map(tab => ({
                        name: tab.name,
                        value: tab.subRoute
                    }))}
                    selectedOption={selectedTab}
                    changeFilter={value => handleChangeTab(value)}
                />
            </div>
        </>
    ) : null;
}

export default PageTabs;